module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7016/img/provider-signup/community-creators-blobs.png"